

(function($){
	
	$.fn.rhImagePop=function(options){
		
		var settings = $.extend({ 
			gutter:30
		},options);
			
		var overlayHTML = '<div id="imageGridOverlayBG" class="imageGridOverlayBG">';
		overlayHTML += '<div class="imageGridOverlayBGInner"><h3>Loading</h3></div>';
		overlayHTML += '</div>';
		overlayHTML += '<div id="imageGridOverlay" class="imageGridOverlay"></div>';
	
		$('body').append(overlayHTML);
	
		var childImage, rect, childTop, childLeft, childRight, childBottom, $imageGridOverlayBG = $('#imageGridOverlayBG'), $imageGridOverlay = $('#imageGridOverlay'), rhImagePopElement = this; 
		
		rhImagePopElement.each(function() {
		  
		  	$(this).on("click", function(e) {
			  		
				e.preventDefault(); 
				
				$('body').addClass('stopScrolling');
	
				
				var $this = $(this);
				
				$imageGridOverlayBG.fadeIn();
				$imageGridOverlay.show();
						
				childImage = $this.data('full');
				
				rect = this.getBoundingClientRect(); 
				childTop = rect.y;
				childLeft = rect.x;
				childRight = window.innerWidth - childLeft - rect.width;
				childBottom = window.innerHeight - childTop - rect.height;	
		
				var theImage = new Image();
		        theImage.src = childImage;
				
				if (theImage.complete) {
					openOverlay();
				} else {
					theImage.addEventListener('load', openOverlay )
					theImage.addEventListener('error', function() { 
						closeOverlay(); 
						$imageGridOverlay.hide().empty();	
					});
				}			
		 
			});
		});		
	
	
		$imageGridOverlay.click( function() { 		
			closeOverlay();	    
		});
		
		
		function openOverlay() {		 
			
			var $newImage = $("<div>");
			
			$newImage.css({
			        position:   				'fixed',
			        'opacity':				0,
			        top:        				childTop+'px',
			        left:       				childLeft+'px',
			        right:     		 		childRight+'px',
			        bottom:     				childBottom+'px',
			        'z-index': 				100,
			        'background-size':		'contain',
			        'background-image':	 	'url(' + childImage + ')',
			        'background-repeat':		'no-repeat',
			        'background-position': 	'center center'
			    });
			    
			$newImage.appendTo($imageGridOverlay);
			
			$imageGridOverlay.imagesLoaded( { background: 'div' }, function() {
	
			  	$newImage.css({"opacity":"1"}).animate({
				    left: settings.gutter + 'px',
				    top: settings.gutter + 'px',
				    right: settings.gutter + 'px',
				    bottom:settings.gutter + 'px'
				}, 200);	
			});
			
		}	
			
		function closeOverlay() {
			
			$imageGridOverlay.find('div').animate({
			     	top:        childTop+'px',
			        left:       childLeft+'px',
			        right:      childRight+'px',
			        bottom:     childBottom+'px'
			    }, 200, function() {			    
			    	$imageGridOverlay.hide().empty();		  
			});			
		
			$imageGridOverlayBG.fadeOut(100);	
			
			$('body').removeClass('stopScrolling');	
			
		}
	
		
	}


}(jQuery));	


